<template>
  <div class="posRecipt">

  <div class="receipt">
    <template  v-if="info.immediate">
    <div>
      <div>即時內用
        <BtnsS v-if="edit==='immediate_instore'" @cancel="edit=null" @save="$emit('update', { immediateInstore })" :style="{ marginLeft: 'auto' }"/>
        <EditBtn @click="immediateInstore=info.immediateInstore;edit='immediate_instore'" v-else :style="{ marginLeft: 'auto' }"/>
      </div>
      <div v-if="edit==='immediate_instore'">
        <label><input type="radio" v-model="immediateInstore" :value="`10`"> 先出單不顯示</label>
        <label><input type="radio" v-model="immediateInstore" :value="`00`"> 先確認</label>
        <label><input type="radio" v-model="immediateInstore" :value="`11`"> 先出單並顯示</label>
      </div>
      <div v-else>{{info.immediateInstore === '10' ? '先出單不顯示' : info.immediateInstore === '00' ? '先確認' : '先出單並顯示' }}</div>
    </div>
    <div>
      <div>即時外帶
        <BtnsS v-if="edit==='immediate_takeout'" @cancel="edit=null" @save="$emit('update', { immediateTakeout })" :style="{ marginLeft: 'auto' }"/>
        <EditBtn @click="immediateTakeout=info.immediateTakeout;edit='immediate_takeout'" v-else :style="{ marginLeft: 'auto' }"/>
      </div>
      <div v-if="edit==='immediate_takeout'">
        <label><input type="radio" v-model="immediateTakeout" :value="`10`"> 先出單不顯示</label>
        <label><input type="radio" v-model="immediateTakeout" :value="`00`"> 先確認</label>
        <label><input type="radio" v-model="immediateTakeout" :value="`11`"> 先出單並顯示</label>
      </div>
      <div v-else>{{info.immediateTakeout === '10' ? '先出單不顯示' : info.immediateTakeout === '00' ? '先確認' : '先出單並顯示' }}</div>
    </div>
    </template>
    <div>
      <div>預約內用
        <BtnsS v-if="edit==='booking_instore'" @cancel="edit=null" @save="$emit('update', { BookingInstore })" :style="{ marginLeft: 'auto' }"/>
        <EditBtn @click="BookingInstore=info.BookingInstore;edit='booking_instore'" v-else :style="{ marginLeft: 'auto' }"/>
      </div>
      <div v-if="edit==='booking_instore'">
        <label><input type="radio" v-model="BookingInstore" :value="`00`"> 先確認</label>
        <label><input type="radio" v-model="BookingInstore" :value="`10`"> 先出單不顯示</label>
      </div>
      <div v-else>{{info.BookingInstore === '10' ? '先出單不顯示' : info.BookingInstore === '00' ? '先確認' : '先出單並顯示' }}</div>
    </div>
    <div>
      <div>預約外帶
        <BtnsS v-if="edit==='booking_takeout'" @cancel="edit=null" @save="$emit('update', { BookingTakeout })" :style="{ marginLeft: 'auto' }"/>
        <EditBtn @click="BookingTakeout=info.BookingTakeout;edit='booking_takeout'" v-else :style="{ marginLeft: 'auto' }"/>
      </div>
      <div v-if="edit==='booking_takeout'">
        <label><input type="radio" v-model="BookingTakeout" :value="`11`"> 先出單並顯示</label>
        <label><input type="radio" v-model="BookingTakeout" :value="`10`"> 先出單不顯示</label>
      </div>
      <div v-else>{{info.BookingTakeout === '10' ? '先出單不顯示' : info.BookingTakeout === '00' ? '先確認' : '先出單並顯示' }}</div>
    </div>
  </div>
  <div>
    <div class="switchs">
      <div>桌邊點菜QRCODE時間設定</div>
      <div>
        <div label="點餐時間" class="min" after="分鐘"><input type="text" :value="info.lastOrder"  @change="$emit('update', { 'lastOrder': $event.target.value })"></div>
        <div label="用餐時間" class="min" after="分鐘"><input type="text" :value="info.dinningTime"  @change="$emit('update', { 'dinningTime': $event.target.value })"></div>
      </div>
    </div>
    <editCube title="桌邊點菜QRCODE說明文字" :defaultValue="info.tableSideQRCODE" @save="$emit('update', { tableSideQRCODE: $event })"/>
  </div>
  </div>
</template>

<script>
import EditBtn from '../../components/btn/edit.vue'
import editCube from '../../components/editCubeV2.vue'
export default {
  props: ['info'],
  components: { EditBtn, editCube },
  data () {
    return {
      edit: null,
      immediateInstore: null,
      immediateTakeout: null,
      BookingInstore: null,
      BookingTakeout: null
    }
  },
  watch: {
    info: {
      deep: true,
      handler () {
        this.edit = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.posRecipt {
  display: grid;
  grid-template-columns: 1fr 1fr;
  &>div:nth-child(2){
    border-left: 1px solid #CACACA;
    padding: 40px 80px;
  }
}
.switchs {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 15px;
  margin-bottom: 15px;
  &>div:nth-child(2) {
    display: flex;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    width: 100%;
    height: 65px;
    align-items: center;
    justify-content: flex-start;
    margin-block: 10px 30px;
    &>div {
      width: 320px;
      height: 65px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-inline: 14px;
      border: 2px dashed var(--color-pri);
      border-radius: 5px;
      &::before {
        content: attr(label);
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
        letter-spacing: 0.1em;
        color: var(--color-letter);
      }
      &.min {
        width: 320px;
      }
      &.min::after{
        content: attr(after);
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
        letter-spacing: 0.1em;
        color: var(--color-letter);
        align-self: x;
      }
    }
    input[type=text] {
      height: 40px;
      width: 100px;
      border: 1px solid #C4C4C4;
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      font-family: Roboto;
      letter-spacing: 2px;
      color: #FF8B8B;
    }
    input[type=checkbox] {
      appearance: none;
      width: 39px;
      height: 20px;
      border-radius: 10px;
      position: relative;
        background-color: #FF8B8B;
      &:checked {
        background-color: #85CA9E;
      }
      &::before {
        content: '';
        display: inline-flex;
        width: 16px;
        height: 16px;
        position: absolute;
        left: 2px;
        right: auto;
        top: 2px;
        background-color: #FFFFFF;
        border-radius: 8px;
      }
      &:checked::before {
        right: 2px;
        left: auto;
      }
      &.invert {
        background-color: #85CA9E;
        &:checked {
          background-color: #FF8B8B;
        }
      }
    }
  }
  &>div:nth-child(1) {
    font-family: "Noto Sans TC";
    font-style: normal;
    font-weight: 400;
    font-size: 25px;
    line-height: 29px;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--color-pri);
    width: -webkit-fill-available;

  }
}
.receipt {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 40px 80px;
  align-items: flex-start;
  justify-content: flex-start;
  &>div{
    &>:nth-child(1) {
      color: var(--color-pri);
      font-family: Roboto;
      font-size: 25px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: 2.5px;
      display: flex;
      width: 500px;
    }
    &>:not(:nth-child(1)){
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 15px;
      margin-block: 20px 40px;
      color: var(--unnamed, #787878);
      /* Noto TC/Regular/20 */
      font-family: Noto Sans TC;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 30px */
      letter-spacing: 1px;
    }
  }
  label {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  label>input[type=radio] {
    appearance: none;
    border-radius: 11px;
    width: 22px;
    height: 22px;
    background-color: #FFFFFF;
    border: 1px solid var(--color-pri);
    display: flex;
    align-items: center;
    justify-content: center;

    &::before {
      content: '';
      display: inline-flex;
      width: 12px;
      height: 12px;
      border-radius: 6px;
    }
    &:checked {
      &::before {
        content: '';
        background-color: var(--color-pri);
      }
    }
  }
}
</style>
